// ProfileCard.js
import React, { useState, useEffect, useCallback } from "react";
import QRCodeGenerator from "./QRCodeGenerator"; // Importa el nuevo componente
import Tripadvisor from "./Tripadvisor";
import Music from "./Music";
import WebSite from "./WebSite";
import Instagram from "./Instagram";
import VCard from "./vCard"; // Importa el componente VCard
import "./ProfileCard.css"; // Importa el archivo CSS

const ProfileCard = () => {
  const [showQRCode, setShowQRCode] = useState(false);
  const [showInfoModal, setShowInfoModal] = useState(false); // Nuevo estado para la ventana modal de información
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 576);

  const handleQRCodeClick = (e) => {
    e.preventDefault();
    setShowQRCode(true);
  };

  const handleCloseQRCode = () => {
    setShowQRCode(false);
  };

  const handleInfoClick = (e) => {
    e.preventDefault();
    setShowInfoModal(true);
  };

  const handleCloseInfoModal = () => {
    setShowInfoModal(false);
  };

  const handleResize = useCallback(() => {
    setIsMobileView(window.innerWidth <= 576);
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [handleResize]);

  return (
    <div className="container">
      <div className="card-container">
        <div className="descripcion">
          <h1>Nisì by Giuseppe</h1>
          <h2>Restaurant</h2>
          <br />
          <a
            href="https://maps.app.goo.gl/Svb4kj2LssqxZ78M7"
            //href="https://www.google.es/maps/place/NIS%C3%8C+by+Giuseppe/@39.8420686,3.1347661,17.09z/data=!4m6!3m5!1s0x12962d22ebf08b07:0x5a73eb9f54440c97!8m2!3d39.841993!4d3.1348116!16s%2Fg%2F11rr_t2tgn"
            className="adress-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <p>Calle dels Pins 7</p>
            <p>07400 Alcúdia (Illes Balears), Spain</p>
          </a>
          <br />
          <p>
            <a
              href="tel:+34971310280"
              className="phone-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="bi bi-telephone" /> +34 971 310 280
            </a>
          </p>
          <div className="buttons">
            <Instagram />
            <Music />
            <Tripadvisor />
            <WebSite />
            <VCard />
          </div>
        </div>
        <div className="fill" />
        <div className="image">
          <img src="/images/profile-image.png" alt="Logo Nisì by Giuseppe" />
          {!isMobileView && (
            // biome-ignore lint/a11y/useButtonType: <explanation>
            <button
              onClick={handleQRCodeClick}
              className="hover-text qr-button"
            >
              <span className="tooltip-text qr-tooltip-text" id="fade">
                {" "}
                QR{" "}
              </span>
              <i className="bi bi-qr-code" />
            </button>
          )}
          {/* biome-ignore lint/a11y/useValidAnchor: <explanation> */}
          <a
            href="#"
            onClick={handleInfoClick}
            className="hover-text info-button"
          >
            <span className="tooltip-text info-tooltip-text" id="fade">
              {" "}
              About{" "}
            </span>
            <i className="bi bi-info-circle" />
          </a>
        </div>
      </div>
      {showQRCode && (
        // biome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
        <div className="qr-code-overlay" onClick={handleCloseQRCode}>
          {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
          <div
            className="qr-code-container"
            onClick={(e) => e.stopPropagation()}
          >
            <QRCodeGenerator value="https://nisibygiuseppe.digitalcard.store/" />
          </div>
        </div>
      )}
      {showInfoModal && (
        // biome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
        <div className="info-modal-overlay" onClick={handleCloseInfoModal}>
          {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
          <div
            className="info-modal-container"
            onClick={(e) => e.stopPropagation()}
          >
            <a
              href="https://sergiohelou.dev/digitalcard/"
              className="hover-text"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>Digital Card</span>
              <span>by</span>
              <span>Sergio Helou Dev</span>
            </a>
          </div>
        </div>
      )}
      {isMobileView && (
        <div className="qr-container">
          {/* biome-ignore lint/a11y/useButtonType: <explanation> */}
          <button onClick={handleQRCodeClick} className="hover-text qr-button">
            <span className="tooltip-text qr-tooltip-text" id="fade">
              {" "}
              QR{" "}
            </span>
            <i className="bi bi-qr-code" />
          </button>
        </div>
      )}
    </div>
  );
};

export default ProfileCard;
